export enum AlarmType {
  'ERROR' = 'ERROR',
  'WARN' = 'WARN',
  'INFO' = 'INFO',
  'SAFETY_STOP' = 'SAFETY_STOP',
}
